"use client";

import Image from "next/image";
import {useTranslation} from "react-i18next";
import Icon from "@/components/library/Icon";

interface ScriptProposalReviewBarProps {
   title: React.ReactNode;
   subtitle: React.ReactNode;
   onClose: () => void;
   /** Decision controls, placed before the close button. */
   actions?: React.ReactNode;
   /** Notices under the bar's header row. */
   children?: React.ReactNode;
   role?: "status";
}

/** Floats above the script while you scroll it, so the decision is always one click away. */
export default function ScriptProposalReviewBar({title, subtitle, onClose, actions, children, role}: ScriptProposalReviewBarProps) {
   const {t} = useTranslation("ask");
   return <div role={role} className="sticky top-4 z-[5] mb-3 rounded-2xl border border-neutral bg-surface/95 px-4 py-3 shadow-lg shadow-black/5 backdrop-blur supports-[backdrop-filter]:bg-surface/85">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-3">
         <div className="flex min-w-0 flex-1 basis-72 items-center gap-3">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-blue-50 dark:bg-blue-950/50">
               <Image src="/icons/gail2-icon-blue.svg" alt="" width={18} height={18} className="h-[18px] w-[18px]" />
            </span>
            <div className="min-w-0">
               {title}
               {subtitle}
            </div>
         </div>
         <div className="ml-auto flex shrink-0 items-center gap-2">
            {actions}
            <button type="button" onClick={onClose} aria-label={t("toolApproval.closeReview")} title={t("toolApproval.closeReview")}
               className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-500 hover:bg-700/10 hover:text-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary">
               <Icon icon="xmark" className="h-4 w-4" />
            </button>
         </div>
      </div>
      {children}
   </div>;
}
